import React from "react";
import PropTypes from "prop-types";
import isMobile from "is-mobile";

import "./Bar.scss";
import HorizontalBar from "./HorizontalBar";
import VerticalBar from "./VerticalBar";

const Bar = ({ isVertical, ...props }) =>
  isVertical ? <VerticalBar {...props} /> : <HorizontalBar {...props} />;

Bar.propTypes = {
  isVertical: PropTypes.bool
};

Bar.defaultProps = {
  isVertical: !isMobile()
};

export default Bar;
